module.exports = __webpack_public_path__ + "img/it-support-pictur.cf995726.jpg";